import * as React from 'react';
import Box from '@mui/material/Box';
import {Card, SwipeableDrawer} from "@mui/material";
import SidebarContent from "../Content/SidebarContent";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
export default function SidebarMobile(props) {

    const drawerWidth = props.width;
    const toggleDrawer = (open) => () => {
        props.setIsOpen(open);
    };


    return (
        <>
            {
                !props.isOpen && (

                    <Card className={'Md-Sidebar-mobile'}
                          sx={{
                              border: '1px solid',
                              borderColor: 'primary.main',
                              zIndex:99
                          }}
                          onClick={toggleDrawer(true)}>
                        <ChevronRightIcon
                            sx={{
                                color: 'primary.main'
                            }}
                        />
                    </Card>
                )
            }
            <SwipeableDrawer
                open={props.isOpen}
                onClose={toggleDrawer(false)}
                onOpen={toggleDrawer(true)}
            >
                <Box
                    sx={{width: drawerWidth + 'px'}}
                    role="presentation"
                    style={{
                        overflowX: 'hidden',
                        height: '100%'
                    }}
                >
                    <SidebarContent
                        width={props.width}
                        isOpen={props.isOpen}
                        setIsOpen={props.setIsOpen}>
                    </SidebarContent>
                </Box>
            </SwipeableDrawer>
        </>
    );
}